import React, { useEffect } from 'react';
import PropTypes, { func } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from '../../../components/Intl/withIntl.js';
import { Container, Card, ButtonGroup, Button, CardImgOverlay, CardImg } from 'react-bootstrap';
import Icon from '../../../components/Content/Icon.js';

import { setStatusCode } from '../../App/AppActions.js';

import PageWrapper from '../../../components/Content/PageWrapper.js';
import { getLanguagePath } from '../../Intl/IntlHelper.js';
import FileLoader from '../../../components/Content/FileLoader.js';
import CmsPanel from '../../Cms/components/content/CmsPanel.js';

function ErrorPage({ dispatch, intl, isSSR, error = null, data = null }) {
    useEffect(() => {
        dispatch(setStatusCode(404));
    }, []);

    if(isSSR) {
        dispatch(setStatusCode(404));
	}

	error && console.error(error);
	data && console.log('ErrorPage::: data', data);
	return (
		<CmsPanel
			slug="404-error"
			defaultDisplay={(
				<Container className="page-wrapper bg-company">
					<PageWrapper>
						<Card className="mt-5 mb-5 shadow text-center">
							<Card.Header>
								<Card.Title>
									<Icon icon="danger" /> <FormattedMessage id="appBackHomeTitle" defaultMessage="Wrong Way..." />
								</Card.Title>
							</Card.Header>
							<Card.Body className="px-3">
								<FormattedMessage id="app404ErrorText" defaultMessage="We didn't find what you're looking for! Go back to homepage or your account" />
								<ButtonGroup className="d-block mt-3    ">
									<Button as={Link} to={getLanguagePath('/', intl.locale)} variant="outline-secondary"><Icon icon="chevron-left" /> <FormattedMessage id="appBackHomeButton" defaultMessage="Back home" /></Button>
									<Button as={Link} to={`/${intl.locale}/user/profile`} variant="outline-primary"><Icon icon="user" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" /></Button>
								</ButtonGroup>
							</Card.Body>
						</Card>
					</PageWrapper>
				</Container>
			)}
		/>
		// <svg viewBox="0 0 800 400" xmlns="http://www.w3.org/2000/svg">
		// 	<defs>
		// 		<linearGradient id="bgGradient" x1="0%" y1="0%" x2="0%" y2="100%">
		// 		<stop offset="0%" style={{ stopColor: '#f8f9fa', stopOpacity: 1 }} />
		// 		<stop offset="100%" style={{ stopColor: '#e9ecef', stopOpacity: 1 }} />
		// 		</linearGradient>
		// 		<linearGradient id="saucissonGradient" x1="0%" y1="0%" x2="100%" y2="0%">
		// 		<stop offset="0%" style={{ stopColor: '#8B4513', stopOpacity: 1 }} />
		// 		<stop offset="50%" style={{ stopColor: '#A0522D', stopOpacity: 1 }} />
		// 		<stop offset="100%" style={{ stopColor: '#8B4513', stopOpacity: 1 }} />
		// 		</linearGradient>
		// 		<pattern id="saucissonTexture" patternUnits="userSpaceOnUse" width="4" height="4">
		// 		<rect width="4" height="4" fill="url(#saucissonGradient)" />
		// 		<circle cx="2" cy="2" r="0.5" fill="#654321" opacity="0.3" />
		// 		</pattern>
		// 	</defs>

		// 	{/* Background */}
		// 	<rect width="800" height="600" fill="url(#bgGradient)" />

		// 	{/* Decorative elements in background */}
		// 	<circle cx="100" cy="100" r="20" fill="#dc3545" opacity="0.1" />
		// 	<circle cx="700" cy="150" r="15" fill="#dc3545" opacity="0.1" />
		// 	<circle cx="150" cy="500" r="25" fill="#dc3545" opacity="0.1" />
		// 	<circle cx="650" cy="450" r="18" fill="#dc3545" opacity="0.1" />

		// 	{/* Main 404 text */}
		// 	<text x="400" y="150" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="120" fontWeight="bold" fill="#dc3545" opacity="0.8">404</text>

		// 	{/* ) */}
		// 	<g transform="translate(500, 150)">
		// 		<circle cx="0" cy="0" r="40" fill="none" stroke="#6c757d" strokeWidth="4" />
		// 		<circle cx="0" cy="0" r="35" fill="white" opacity="0.4" />
		// 		<line x1="28" y1="28" x2="50" y2="50" stroke="#6c757d" strokeWidth="4" strokeLinecap="round" />
		// 		{/* " */}
		// 		<line x1="-15" y1="-15" x2="15" y2="15" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" />
		// 		<line x1="15" y1="-15" x2="-15" y2="15" stroke="#dc3545" strokeWidth="3" strokeLinecap="round" />
		// 	</g>

		// 	{/* e */}
		// 	<text x="400" y="260" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="18" fill="#6c757d">La page que vous cherchez a disparu plus vite qu'un saucisson à l'apéro...</text>

		// 	{/* n */}
		// 	<Button as={Link} to={getLanguagePath('/', intl.locale)} variant="outline-secondary">
		// 		<g transform="translate(300, 300)">
		// 			<rect x="0" y="0" width="200" height="50" rx="25" fill="#dc3545" stroke="none" />
		// 			<text x="100" y="32" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="white">Retour à la charcuterie</text>
		// 		</g>
		// 	</Button>

		// 	{/* s */}
		// 	<g transform="translate(80, 350)">
		// 		<circle cx="0" cy="0" r="15" fill="#A0522D" stroke="#654321" strokeWidth="1" />
		// 		<circle cx="0" cy="0" r="12" fill="#CD853F" />
		// 		<circle cx="-5" cy="-3" r="2" fill="#8B4513" />
		// 		<circle cx="4" cy="2" r="1.5" fill="#8B4513" />
		// 	</g>

		// 	<g transform="translate(720, 380)">
		// 		<circle cx="0" cy="0" r="18" fill="#A0522D" stroke="#654321" strokeWidth="1" />
		// 		<circle cx="0" cy="0" r="15" fill="#CD853F" />
		// 		<circle cx="-6" cy="-4" r="2.5" fill="#8B4513" />
		// 		<circle cx="5" cy="3" r="2" fill="#8B4513" />
		// 		<circle cx="0" cy="8" r="1" fill="#8B4513" />
		// 	</g>
		// </svg>
	);
}

function mapStateToProps(store, props) {
    return {
        isSSR: store.app.isSSR,
    };
}

ErrorPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    isSSR: PropTypes.bool.isRequired,
	error: PropTypes.object,
	data: PropTypes.object,
};

export default connect(mapStateToProps)(injectIntl(ErrorPage));
